import { Controller } from "@hotwired/stimulus";

// Connects to data-controller="active-link"
export default class extends Controller {
  connect() {
    this.boundHandleClick = () => this.handleClick();
    this.element.addEventListener("click", this.boundHandleClick);

    // This is a bit of a hack. Ideally, we use Turbo frames to not re-render
    // a list but if that isn't possible then we can use this to ensure the
    // active element is visible.
    if (this.element.dataset.scrollIntoView === "true") {
      if (this.element.classList.contains("active")) {
        // Waits for paint before scrolling
        requestAnimationFrame(() => {
          this.scrollIntoView();
          // Just in case that was too early, wait for the next
          // frame and do it again.
          requestAnimationFrame(() => {
            this.scrollIntoView();
          });
        });
      }
    }
  }

  scrollIntoView() {
    this.element.scrollIntoView({
      block: "center",
      behavior: "instant",
    });
  }

  disconnect() {
    this.element.removeEventListener("click", this.boundHandleClick);
  }

  handleClick() {
    const otherElements = document.querySelectorAll(".admin-list a.active");
    otherElements.forEach((element) => {
      element.classList.remove("active");
    });
    this.element.classList.add("active");
  }
}
